
import React, { useEffect, useState } from 'react';
import RatioButton from '../../subComponents/gacha/RatioButton'
import { LoadingScreen } from '../loading/LoadingScreen'
import PurchaseButton from '../../subComponents/gacha/PurchaseButton'
import GachaEffectVideo from '../../subComponents/gacha/GachaEffectVideo'
import { Link } from 'react-router-dom';
import { preloadImage, withTimeout } from '../../utils/media/preload';
import '../../../styles/gacha/result.sass';

// 画像が読み込めない場合でも結果画面へ進めるための上限時間(ミリ秒)
const IMAGE_PRELOAD_TIMEOUT_MS = 8000;

type PlayAfterProps = {
  teamColor: string,
  tickets: number,
  teamName: string,
  type: string,
  product_code: string,
  productValiationId: string,
  productValiationName: string,
  rarityName: string,
  rarityGroup: string,
  rareEffect: string,
  videoName: string,
  setProductValiationId: React.Dispatch<React.SetStateAction<string>>,
  setRarityName: React.Dispatch<React.SetStateAction<string>>,
  setRarityGroup: React.Dispatch<React.SetStateAction<string>>,
  setProductValiationName: React.Dispatch<React.SetStateAction<string>>,
  setTickets: React.Dispatch<React.SetStateAction<number>>,
  setRareEffect: React.Dispatch<React.SetStateAction<string>>,
  setVideoName: React.Dispatch<React.SetStateAction<string>>,
}

export const PlayAfter: React.FC<PlayAfterProps> = ({ teamColor, tickets, teamName, type, product_code, productValiationId, productValiationName, rarityName, rarityGroup, rareEffect, videoName, setProductValiationId, setRarityName, setRarityGroup, setProductValiationName, setTickets, setRareEffect, setVideoName }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showVideo, setShowVideo] = useState(true);
  const [imagesReady, setImagesReady] = useState(false);

  const cardImageSrc = `/image/${teamName}/${product_code}/${String(productValiationId).padStart(8, '0')}.jpg`;
  const coverImageSrc = `/image/${teamName}/${product_code}/${type}-result.jpg`;


  // カード画像とカバー画像を動画の再生中に先読みしておく。
  // 両方揃うまで結果画面を組み立てないことで、カバーが間に合わずカードが
  // 一瞬見えてしまうのを防ぐ。
  useEffect(() => {
    let cancelled = false;
    setImagesReady(false);

    withTimeout(
      Promise.all([preloadImage(cardImageSrc), preloadImage(coverImageSrc)]),
      IMAGE_PRELOAD_TIMEOUT_MS,
    ).then(() => {
      if (!cancelled) {
        setImagesReady(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [cardImageSrc, coverImageSrc]);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  if (loading) {
    return <LoadingScreen />;
  }

  // 演出のレアリティ区分に合わせてレア表現を出し分ける(R/SN/LN は N と同じ下位扱い)
  const isRare = rarityGroup !== 'N';

  if (showVideo) {
    return (
      <GachaEffectVideo videoName={videoName} onFinished={() => setShowVideo(false)} />
    );
  }

  // 動画中に先読みが終わっていれば素通りする
  if (!imagesReady) {
    return <LoadingScreen />;
  }

  return (
    <div className='mainSection'>
      <div id="gacha-result" onClick={() => setIsClicked(true)}>
        <div className="background-effect" />
        <p className={`getText fs-title fw-bold text-center ${isRare ? 'rare' : 'normal'} ${isClicked ? 'visible' : 'invisible'}`} id="result-title">
          選手獲得!!
        </p>
        <div className="card-drow-animation">
          <div className={`cardArea mb-3 ${rareEffect === "RareEffect1" ? 'text-shadow-rare' : 'text-shadow-normal'} ${isClicked ? 'flipped' : 'flip'}`}>
            <img className='back' src={cardImageSrc} alt={productValiationName} />
            <img className="front" alt="front" src={coverImageSrc} />
          </div>
          <p className={`text ${rareEffect === "RareEffect2" ? 'text-shadow-rare' : ''} ${isClicked ? 'invisible' : 'visible'}`} id="touched">タッチしてください</p>
        </div>
        <p id="result-name" className={`getText fs-title2 fw-bold text-center  ${isRare ? 'rare' : 'normal'} ${isClicked ? 'visible' : 'invisible'}`}>
          {rarityName}<br />
          {productValiationName}
        </p>
      </div >
      <div className={`bg-cleargray w-250 mx-auto mt-2 p-2 visible`}>
        <p className="fs-caption m-2 text-danger text-center">
          カードの保存期間は獲得から90日です。90日を過ぎた保有カードについては、発送の保証ができかねますのでご了承をお願いいたします。
        </p>
        {
          Number(tickets) > 0 ?
            <>
              <span className='d-block text-center'>所持チケット：{tickets}</span>
              <PurchaseButton
                teamColor={teamColor}
                product_code={product_code}
                setRareEffect={setRareEffect}
                setVideoName={setVideoName}
                setProductValiationId={setProductValiationId}
                setProductValiationName={setProductValiationName}
                setRarityName={setRarityName}
                setRarityGroup={setRarityGroup}
                setTickets={setTickets}
                setLoading={setLoading}
                setIsClicked={setIsClicked}
                onPurchased={() => setShowVideo(true)}
              />
              <RatioButton teamColor={teamColor} product_code={product_code}></RatioButton>
            </>
            :
            <>
              <span className="d-block text-center text-danger fw-bold">所持チケット：{tickets}</span>
              <Link className={`bg-${teamColor}-primary btn w-75 mx-auto m-2`} to="/ticket">チケットを購入する</Link>
            </>
        }
        {/* <a className="btn btn-secondary w-250 mx-auto my-2 py-1" href="{{ url('/album') }}">アルバムを見る</a> */}
        <p className="text-center"><a href="/transaction">特定商取引法に基づく表記</a></p>
      </div >
    </div>
  );
}

export default PlayAfter;
